import { useEffect, useState } from 'react';

/**
 * MUI's `md` breakpoint, kept to the pixel.
 *
 * This gates the desktop/mobile component router across the app, so it deliberately does NOT
 * follow Tailwind's `md` (768px). Changing this number silently moves every breakpoint in the
 * app — see §9 of `.claude/design-system/index.md`.
 */
const MOBILE_QUERY = '(max-width: 899.98px)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    // Re-read on mount: the viewport can have changed between the initial state and this effect.
    setIsMobile(query.matches);
    query.addEventListener('change', handleChange);

    return () => query.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}
